import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectContactPhone } from '../../../../../../store/selectors/contact'

const PrequalContactPhoneLinkContainer = compose(
  connect(
    state => ({
      value: selectContactPhone(state)
    }),
    dispatch => ({})
  )
)

export default PrequalContactPhoneLinkContainer
